const style = (theme) => {
  const output = {
    root: {
      '& form': {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: 50,
      },
    },
    formControl: {
      width: '50%',
      padding: '0 10px',
      position: 'relative',
    },
    formControlCheckbox: {
      width: '80%',

    },

    // Generic Input
    input: {
      width: '100%',
      color: theme.colors[2],
      appearance: 'none',
      padding: '10px 20px',
      fontSize: 16,
      fontWeight: 300,
      fontFamily: theme.fonts[0],
      border: 'none',
      background: theme.getRgba(theme.colors[2], 0.05),
      borderRadius: 23,
      marginBottom: 38,
      '&::placeholder': {
        color: theme.getRgba(theme.colors[0], 0.3),
      },
    },

    // Textarea
    textarea: {
      width: '100%',
      color: theme.colors[2],
      background: theme.getRgba(theme.colors[2], 0.05),
      appearance: 'none',
      padding: '10px 20px',
      fontSize: 16,
      fontFamily: theme.fonts[0],
      border: 'none',
      fontWeight: 300,
      borderRadius: 23,
      marginBottom: 38,
      resize: 'none',
    },

    // Select
    select: {
      width: '100%',
      color: theme.colors[2],
      background: theme.getRgba(theme.colors[2], 0.05),
      padding: '10px 20px',
      appearance: 'none',
      fontSize: 16,
      fontFamily: theme.fonts[0],
      border: 'none',
      marginBottom: 38,
      fontWeight: 300,
      borderRadius: 23,
    },
    selectArrow: {
      position: 'absolute',
      zIndex: 1,
      top: 17,
      right: 30,
      width: 10,
      height: 10,
      fill: theme.colors[0],
    },

    // Checkbox
    checkbox: {
      position: 'relative',
      zIndex: 1,
      overflow: 'hidden',
      fontSize: 11,
      '& input[type="checkbox"]': {
        position: 'absolute',
        top: 0,
        left: 0,
        opacity: 0.001,
      },
      '& input[type="checkbox"] + span': {
        display: 'inline-block',
        paddingLeft: 22,
        position: 'relative',
        zIndex: 1,
        '& a': {
          color: 'currentColor',
        },
        '&:before': {
          content: '""',
          position: 'absolute',
          cursor: 'pointer',
          zIndex: 1,
          top: 0,
          left: 0,
          width: 13,
          height: 13,
          borderRadius: 10,
          border: `1px solid ${theme.getRgba(theme.colors[2], 0.1)}`,
          background: theme.getRgba(theme.colors[2], 0.1),
          transition: 'all .2s ease-in-out',
        },
      },
      '& input[type="checkbox"]:checked + span': {
        '&:before': {
          background: theme.colors[1],
          boxShadow: `inset 0 0 0 3px ${theme.colors[0]}`,
        },
      },
    },

    formControlTextarea: {
      width: '100%',
    },

    // Submit
    formControlSubmit: {
      marginTop: 30,
    },
    submit: {
      fontSize: 12,
      letterSpacing: 1,
      textTransform: 'uppercase',
      display: 'inline-block',
      padding: '10px 30px',
      borderRadius: 20,
      color: theme.colors[1],
      background: theme.colors[0],
      verticalAlign: 'middle',
      transition: `background .3s ${theme.easings['power4.out']}, color .3s ${theme.easings['power4.out']}`,
      cursor: 'pointer',
      '& span': {
        display: 'inline-block',
      },
      '&:hover': {
        background: theme.colors[6],
        color: theme.colors[0],
      },
    },

    // Message
    message: {
      flex: '1 1 100%',
      marginTop: 40,
      paddingLeft: 20,
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    formControl: {
      width: '100%',
    },
    message: {
      paddingLeft: 10,
    },
  }

  return output
}

export default style
